import { render, staticRenderFns } from "./BrBookCover.vue?vue&type=template&id=5ed0307b&"
import script from "./BrBookCover.vue?vue&type=script&lang=js&"
export * from "./BrBookCover.vue?vue&type=script&lang=js&"
import style0 from "./BrBookCover.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports